<script lang="ts">
  import type { Map } from "../../types";
  import type { Point } from "../../support/geometry";
  import { MAP_WIDTH, MAP_HEIGHT } from "../../constants";
  import MapIcons from "./map-icons.svelte";
  import CurrentEvents from "./current-events.svelte";
  import MapTextbox from "./map-textbox.svelte";
  import Scroller from "./scroller.svelte";
  import ImageTile from "./image-tile.svelte";
  import { writable } from "svelte/store";
  import { get } from "lodash-es";

  export let map: Map;
  export let positionX = writable(0);
  export let positionY = writable(0);
  export let positionZ = writable(1);
  export let initialZoom = 1;
  export let point: Point;

  $: waypoint = { id: "point", x: point.x, y: point.y, type: "circle", r: 30 };

  $: layers = get(map, "template.layerImages", []);
  $: width = get(map, "template.width", MAP_WIDTH);
  $: height = get(map, "template.height", MAP_HEIGHT);
  $: fonts = get(map, "fonts", []);
  $: textboxes = get(map, "textboxes", []);
  $: focus = { x: point.x - 200, y: point.y - 200, width: 400, height: 400 };

  let zoom = initialZoom;

  function onZoom(event: { detail: number }) {
    zoom = event.detail;
  }
</script>

<svelte:head>
  {#each fonts as font}
    <link rel="stylesheet" href={font.resourceUrl} />
  {/each}
</svelte:head>

<Scroller
  {positionX}
  {positionY}
  {positionZ}
  {initialZoom}
  {width}
  {height}
  {focus}
  on:zoom={onZoom}
>
  <ImageTile {layers} {width} {height} />

  <MapIcons icons={map.icons} />

  {#each textboxes as textbox}
    <MapTextbox {textbox} {map} {zoom} stroke={map.textStrokeColor} />
  {/each}

  <CurrentEvents
    {width}
    {height}
    {zoom}
    waypoints={[waypoint]}
    activeWaypointId={waypoint.id}
    showActiveWaypoint
  />
</Scroller>
